module.exports = __webpack_public_path__ + "static/media/img--728x400.527e4fad.527e4fad.webp";